module.exports = __webpack_public_path__ + "img/ssGreySearch.f9d1b16d.svg";